export const FinalDocStatus = 'final';
export const PreliminaryDocStatus = 'preliminary';
export const PendingDocStatus = 'pending';
export const DocStatuses = [FinalDocStatus, PreliminaryDocStatus, PendingDocStatus];
//# sourceMappingURL=types.js.map